function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.83 72.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.88,4.02c-3.05,6.94-5.79,19.59-6.46,29.83-.34,5.22-1.29,12.33-2.1,15.78-.81,3.46-1.76,9.32-2.11,13.03-.78,8.37.21,9.44,9.22,10.02,4.77.3,7.03,0,8.89-1.23,2.39-1.56,2.5-2.09,2.5-11.39,0-7.68-.37-10.28-1.75-12.23-1.5-2.12-1.82-5.68-2.25-24.96C16.38,2.36,16.17.34,14.56.03c-1.27-.24-2.31.88-3.67,3.99",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.62,23.35l.29,20.5H6.05l.47-8.75c.47-8.84,3.28-22.55,5.91-28.83.79-1.88,1.53-3.42,1.66-3.42.13,0,.37,9.23.52,20.5",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.29,46.47c3.02,1.16,4.55,5.94,4.55,14.29,0,9.66-.78,10.41-9.64,9.31l-5.86-.73-.3-5.33c-.4-6.97,1.49-15.88,3.62-17.13,1.94-1.13,5.3-1.32,7.64-.42",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg22);
export default __webpack_public_path__ + "static/media/22.ac31a8d3fc08eb172bfda074e797db3f.svg";
export { ForwardRef as ReactComponent };